import throttle from 'nespresso-library/src/utils/throttle'
import scrollTo from 'nespresso-library/src/utils/scrollTo'
import queryParams from 'nespresso-library/src/utils/queryParams'

export default {
    install (Vue) {
        const anchorQuery = Object.keys(queryParams)

        // No parameter, no anchor to handle
        if (anchorQuery.length < 0) {
            // No anchor, no need to add function to the directive, still declare it to not break the components
            Vue.directive('anchor')
            return
        }

        // Matched the query parameter and the directive
        let matched = false
        // Call back to start the scroll to the position wanted
        let cb

        // Prevent browser to manage scroll
        if ('scrollRestoration' in history) {
            // Back off, browser, I got this...
            history.scrollRestoration = 'manual'
        }

        // Call the scroll after lazy load images
        // const observer = new MutationObserver(mutations => {
        //     const BreakException = {}
        //     try {
        //         mutations.forEach(mutation => {
        //             if (mutation.type !== 'attributes') {
        //                 return
        //             }
        //
        //             if (mutation.target.classList &&
        //                 !mutation.target.classList.contains('g_imgSrc_outOfScreen')) {
        //                 cb()
        //
        //                 // Break the foreach
        //                 // eslint-disable-next-line no-constant-condition
        //                 if (1 === 2) {
        //                     throw BreakException
        //                 }
        //             }
        //         })
        //     } catch (e) {
        //         if (e !== BreakException) {
        //             throw e
        //         }
        //     }
        // })

        Vue.directive('anchor', {
            inserted (el, { value }, { context }) {
                // Previous anchor directive has matched, skip this one
                if (matched) {
                    return
                }

                const { anchor, top, topMobile } = value

                // Check if directive anchor corresponds to the current anchor
                if (anchorQuery.indexOf(anchor) < 0) {
                    return
                }

                matched = true

                // Change the calculated position due to the fixed header
                const correction = (context.$breakpoint.isS ? topMobile : top) || 0

                // Allow to recalculate the position if we are lazy loading images
                // observer.observe(context.$el, {
                //     attributes: true,
                //     subtree: true,
                //     attributeFilter: ['class']
                // })

                cb = throttle(() => scrollTo(el.offsetTop + correction, 2000), 450)
                // If nothing happen after 2s, shutdown the mutation observer
                // setTimeout(() => observer.disconnect(), 2000)
                cb()
            }
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/gvue/src/assets/js/directives/VueAnchor.js